import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { ModalLoading } from "../../../../../../common/components/modal_loading";
import FormContainer from "../../../../../../common/components/form_container";
import PrimaryButton from "../../../../../../common/components/primary_button";
import { MaskedInput } from "../../../../../../common/components/masked_inputs/masked_input";

/**
 * CopyCargoModal
 */

type Props = {
  open: boolean,
  saving: boolean,
  onSubmit: (numeroCopias: string | null) => Promise<void>,
  onClose: (idCargo: number | null, openState: boolean) => void,
};

export const CopyBlocoModal = ({
  open,
  saving,
  onSubmit,
  onClose,
}: Props) => {
  const [numeroCopias, setNumeroCopias] = useState<string>();

  useEffect(() => {
    if (open) {
      setNumeroCopias("__")
    }
  }, [open]);

  const handleClose = useCallback(() => {
    if (!saving) onClose(null, false);
  }, [saving, onClose]);

  return (
    <Dialog
      open={open}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "45rem",
          },
        },
      }}>
      <DialogTitle>
        Copiar Informações do bloco
      </DialogTitle>

      <DialogContent>
        <ModalLoading loading={saving}>
          <FormContainer title={"Informações"} arrangement="fullRow">
            <>
              <MaskedInput
                name="numeroCopias"
                label="N° de Copias"
                mask="00"
                maskPlaceholder="__"
                value={numeroCopias ?? null}
                onChange={val => setNumeroCopias(val)} />
            </>
          </FormContainer>
        </ModalLoading>
      </DialogContent>

      <DialogActions>
        <div className="w-full h-full items-center justify-end flex p-4 gap-4">
          <div className="flex flex-row gap-2">
            <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
              <h1
                className="text-sm text-black dark:text-white"
                onClick={handleClose}>
                Cancelar
              </h1>
            </div>

            <div className="w-[120px]">
              {saving ? (
                <PrimaryButton
                  buttonColor="primary-green">
                  Salvando...
                </PrimaryButton>
              ) : (
                <PrimaryButton
                  buttonColor="primary-green"
                  onClick={async () => { if (!saving) await onSubmit(numeroCopias ?? null); }}>
                  Salvar
                </PrimaryButton>
              )}
            </div>
          </div>
        </div>
      </DialogActions>
    </Dialog>
  );
}